import './App.css';
import Content from './components/Content';
import Navbar from './components/Navbar';

function App() {
  return (
    <div>
      <Navbar />
      <Content />
    </div>
  );
}

export default App;
